"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconType = void 0;
var IconType;
(function (IconType) {
    IconType["Dragon"] = "dragon";
    IconType["Hammer"] = "hammer";
    IconType["Alien"] = "alien";
    IconType["Football"] = "football";
    IconType["Android"] = "android";
    IconType["Spider"] = "spider";
    IconType["Aquarium"] = "aquarium";
    IconType["Bandana"] = "bandana";
    IconType["Beaver"] = "beaver";
    IconType["Gecko"] = "gecko";
    IconType["Owl"] = "owl";
    IconType["Duck"] = "duck";
    IconType["BadgerLogo"] = "badgerLogo";
    IconType["GeckoLogo"] = "geckoLogo";
    IconType["OwlLogo"] = "owlLogo";
    IconType["PlatypiLogo"] = "platypiLogo";
})(IconType || (exports.IconType = IconType = {}));
